<!--
 * @Author: FengXiao
 * @Date: 2020-07-02 15:09:29
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-19 16:01:56
-->
<template>
  <div class="tab-wanxiang-page page-container">
    <div class="banner-bl">
      <div class="banner-content">
        <span class="banner-title">一席会员</span>
        <div class="banner-slogan">
          <p>会员有效期内，可免费观看全部万象课程。</p>
          <p>
            已上线
            <span class="total_numbers">{{ total }}</span>
            门课程，持续更新中。
          </p>
        </div>
        <div class="actions-bl">
          <div class="join_btn btn" @click="showPayDialog(false)">
            {{ vipInfo.status === 1 ? '续费会员' : '加入会员' }}
          </div>
          <div class="gaving_btn btn" @click="showPayDialog(true)" v-if="vipInfo.status === 1">
            赠送
          </div>
        </div>
      </div>
    </div>
    <div class="wanxiang-bl content">
      <div class="wanxiang-item" v-for="(item, index) in dataList" :key="item.id" @click="gotoDetail(item, 1)">
        <div class="wanxiang_cover">
          <img class="wanxiang_cover-img" :src="item.cover" :alt="item.title" srcset="" />
          <div class="shadow" v-if="item.is_putaway === 0">
            即将上线
          </div>
        </div>
        <div class="wanxiang_info">
          <div class="wanxiang_title">
            {{ item.title }}
            <span class="wanxiang_price" :class="{ free: getWanXiangPrice(item) === '免费' }" v-if="getWanXiangPrice(item)">{{
              getWanXiangPrice(item)
            }}</span>
          </div>
          <template v-if="item.is_putaway !== 0">
            <swiper class="swiper" :options="swiperOptions(index)" :ref="`${item.id}Swiper`">
              <!-- itemIndex：万象课程index, videoIndex：分集的index -->
              <swiper-slide v-for="(video, i) in item.videos" :key="video.id">
                <div class="video-item" @click.stop="gotoDetail(item)">
                  <i class="iconfont iconplayer"></i>
                  <span class="video_title">
                    <span class="video_no">{{ (i + 1) | formatIndex }}</span>
                    {{ video.title }}
                  </span>
                  <span class="video_time">{{ video.time }}</span>
                </div>
              </swiper-slide>
            </swiper>
            <div class="swiper-btns" v-if="item.videos.length > 3">
              <div class="swiper-btn-prev swiper-btn" :class="`swiper-${index}`" @click.stop>
                <i class="iconfont iconarrow-up"></i>
              </div>
              <div class="swiper-btn-next swiper-btn" :class="`swiper-${index}`" @click.stop>
                <i class="iconfont iconarrow-down"></i>
              </div>
            </div>
          </template>
          <div class="video_intro" v-else>{{ item.intro }}</div>
        </div>
      </div>
      <div class="load_more_btn" v-show="!isLoadedAll" @click="loadMore">加载更多</div>
    </div>
    <pay-dialog ref="payDialog" v-model="payPopup" :options="payDialogOptions" dialog-type="vip" @showPayResult="showPayResult"></pay-dialog>
    <pay-result-dialog v-model="payResultVisible" :id="orderId" type="vip"></pay-result-dialog>
  </div>
</template>

<script>
import requestApi from '@/service';
import PayDialog from '@/components/AppPayDialog';
import PayResultDialog from '@/components/AppPayResultDialog';
import { mapState } from 'vuex';

const SWIPER_PAGE_SIZE = 3;
export default {
  components: {
    PayDialog,
    PayResultDialog,
  },
  data() {
    return {
      payPopup: false,
      // 分页
      pageNum: 1,
      pageSize: 4,
      total: 0,
      dataList: [],
      payDialogOptions: {},
      payResultVisible: false,
      orderId: '', // 订单id
    };
  },
  beforeRouteEnter(to, from, next) {
    if ((from.path === '/' || !from.path) && to.query.oId) {
      window.$router.replace({
        name: 'WanXiang',
        params: {
          oId: to.query.oId,
        },
      });
    } else {
      next(vm => {
        if (to.params.oId) {
          vm.showPayResult(to.params.oId);
        }
      });
    }
    /* next(vm => {
      if (to.query.oId && (from.path === '/' || !from.path)) {
        vm.showPayResult(to.query.oId);
      }
    }); */
  },
  mounted() {
    this.getData();
    this.initScrollTop();
    if (this.$route.params.oId) {
      this.showPayResult(this.$route.params.oId);
    }
  },
  filters: {
    formatIndex(i) {
      return i < 10 ? `0${i}` : i;
    },
  },
  computed: {
    ...mapState(['vipInfo']),
    isLoadedAll() {
      return this.total / this.pageSize <= this.pageNum;
    },
  },
  methods: {
    getData() {
      requestApi('/api/site/wanxiang/extend/', {
        page: this.pageNum,
        page_size: this.pageSize,
      }).then(res => {
        if (this.pageNum === 1) {
          this.total = res.total;
          this.dataList = this.handleData(res.items);
        } else {
          this.dataList = this.dataList.concat(this.handleData(res.items));
        }
      });
    },
    loadMore() {
      if (!this.isLoadedAll) {
        this.pageNum += 1;
        this.getData();
      }
    },
    handleData(data) {
      return data;
    },
    showPayDialog(isGaving = false) {
      if (this.checkLogin()) {
        this.payDialogOptions = {
          isGaving,
        };
        this.payPopup = true;
      }
    },
    /**
     * @description: 前往万象详情
     */
    gotoDetail(data, isColumn = 0) {
      const id = data.id;
      const episodeId = data.videos[0].id;
      if (!data.already_bought && +data.pay_type !== 0) {
        isColumn = 1;
      }
      this.$router.push({
        path: '/wanxiang/detail',
        query: {
          id,
          episodeId,
          isColumn,
        },
      });
    },
    swiperOptions(index) {
      const obj = {
        direction: 'vertical',
        slidesPerView: SWIPER_PAGE_SIZE,
        slidesPerGroup: SWIPER_PAGE_SIZE,
        spaceBetween: 10,
        navigation: {
          prevEl: `.swiper-btn-prev.swiper-${index}`,
          nextEl: `.swiper-btn-next.swiper-${index}`,
        },
      };
      return obj;
    },
    /**
     * @description: 价格展示
     * 非会员 价格为0免费展示免费；会员 展示实物价格
     * comprehensive_discount_price > article_discount_price > price > 免费
     */
    getWanXiangPrice(data) {
      let res = '';
      if (+data.pay_type !== 0) {
        // undefined说明用户未登录
        if (+data.already_bought_article !== 0 || data.already_bought_article === undefined) {
          // 判断 是否购买实物
          res = +data.comprehensive_discount_price || +data.article_discount_price;
          res = res ? `${res}元` : '';
        }
        if (!res && ((data.already_bought === 0 && +data.price) || data.already_bought === undefined)) {
          // 收费未购买
          res = `${+data.price}元`;
        }
      } else if (this.vipInfo.status !== 1) {
        res = '免费';
      }
      return res;
    },
    showPayResult(orderId) {
      this.orderId = orderId;
      this.payResultVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-wanxiang-page {
  .banner-bl {
    height: 260px;
    width: 100%;
    background: url('../assets/imgs/speech-bg.jpg') no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    box-sizing: border-box;
    .banner-content {
      width: 80%;
      height: 100%;
      margin: 0 auto;
      max-width: 1140px;
      color: $C1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .banner-title {
        font-size: 47px;
        margin: 0;
        line-height: 1.5;
        letter-spacing: 3px;
        font-family: HYXinRenWenSongW;
      }
      .banner-slogan {
        font-family: HYXinRenWenSongW;
        p {
          line-height: 18px;
        }
      }
    }
    .btn {
      width: 98px;
      height: 40px;
      line-height: 40px;
      border: 1px solid $C2;
      text-align: center;
      cursor: pointer;
      font-family: HYXinRenWenSongW;
      display: inline-block;
    }
    .join_btn {
      background: $C2;
      color: $C1;
      margin-right: 20px;
    }
    .gaving_btn {
      background: transparent;
      border-color: $C1;
      color: $C1;
    }
  }
  .wanxiang-bl {
    .wanxiang-item {
      width: 100%;
      height: 285px;
      background: $C1;
      display: flex;
      margin: 40px 0;
      cursor: pointer;
      position: relative;
      border: 1px solid $C11;
      .wanxiang_cover {
        width: 410px;
        height: 100%;
        position: relative;
        .shadow {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 2;
          background: rgba(0, 0, 0, 0.7);
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: HYXinRenWenSongW;
          color: $C1;
          font-size: 18px;
          letter-spacing: 1px;
        }
      }
      .wanxiang_info {
        flex: 1;
        position: relative;
        padding: 20px 50px;
        .wanxiang_title {
          font-family: HYXinRenWenSongW;
          color: $C6;
          margin: 10px 0 20px;
          letter-spacing: 0;
          font-size: 24px;
          line-height: 24px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          .wanxiang_price {
            font-family: initial;
            color: $C3;
            font-size: 14px;
            line-height: 20px;
            &.free {
              color: $C2;
            }
          }
        }
        .swiper {
          height: 150px;
        }
        .video-item {
          display: flex;
          align-items: center;
          background: $C10;
          padding: 12px 20px 13px 13px;
          box-sizing: border-box;
          .iconfont {
            color: $C3;
            font-size: 18px;
          }
          .video_title {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: $C3;
            line-height: 14px;
            margin-left: 12px;
            flex: 1;
          }
          .video_time {
            color: #bdbdbd;
            font-size: 14px;
            font-weight: 200;
            font-family: Avenir-Book;
          }
        }
        .video_intro {
          font-size: 24px;
          line-height: 35px;
          letter-spacing: 1px;
          color: #4a4a4a;
          font-weight: 300;
        }
      }
    }
  }
}
</style>
